// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__31Fui","notes":"Notes_notes__2DR-6"};